import { createSlice } from '@reduxjs/toolkit';
import { Status } from '../../projects/projectsSlice';

const poSlice = createSlice({
  name: 'managePo',
  initialState: {
    data: [],
    searchResults: [],
    po: {
      status: Status.idle,
      loading: false,
      data: {},
      error: '',
    },
    error: '',
    status: Status.idle,
    loading: false,
  },
  reducers: {
    resetPOs: (state) => {
      state.data = [];
      state.po = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
      state.error = '';
      state.status = Status.idle;
      state.loading = false;
    },
    resetPO: (state) => {
      state.po = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
    },
  },
});
export const getAllPOs = (state) => {
  return {
    data: state.po.data,
    status: state.po.status,
    loading: state.po.loading,
  };
};

const actions = poSlice.actions;

export { actions };
export default poSlice.reducer;
